import EntityDescription from 'src/store/entities/types/EntityDescription';

export const EntityDescriptions = {
    REPRESENTATIVE: new EntityDescription('representatives'),
    PRODUCT: new EntityDescription('products'),
    PRODUCT_GROUP: new EntityDescription('productgroups'),
    VOLUME_DISCOUNT: new EntityDescription('volumediscounts'),
    PRODUCTS: new EntityDescription('products'), // AdminPanel
    ARTICLE_GROUPS_LIST: new EntityDescription('articleGroup/list'), // AdminPanel
    ARTICLE_ARTICLES_LIST: new EntityDescription('article/list'), // AdminPanel
    ARTICLE_COMMISSION_MODELS: new EntityDescription('commissionModels/list'), // AdminPanel
    VIDEO_CATEGORIES: new EntityDescription('video/admin/videoCategories'), // AdminPanel
    ADYEN_BATCH_FILES_LIST: new EntityDescription('batch/adyen/list'), // AdminPanel
};
